<template>
  <div class="profile-container">
    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="avatar-section">
        <div class="avatar">
          <i class="bi bi-person-circle fs-1"></i>
        </div>
        <button class="edit-avatar-btn">
          <i class="bi bi-camera"></i>
        </button>
      </div>
      
      <div class="user-info">
        <h2>{{ userProfile.name }}</h2>
        <p class="user-email">{{ userProfile.email }}</p>
        <p class="user-bio">{{ userProfile.bio }}</p>
        <div class="user-stats">
          <div class="stat-item">
            <span class="stat-number">{{ userProfile.likedCount }}</span>
            <span class="stat-label">点赞</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ userProfile.collectedCount }}</span>
            <span class="stat-label">收藏</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ articles.length }}</span>
            <span class="stat-label">阅读</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 个人资料详情 -->
    <div class="profile-details">
      <div class="detail-item">
        <i class="bi bi-calendar-check"></i>
        <div>
          <span class="label">加入时间</span>
          <span class="value">{{ formatDate(userProfile.joinDate) }}</span>
        </div>
      </div>
      <div class="detail-item">
        <i class="bi bi-envelope"></i>
        <div>
          <span class="label">邮箱</span>
          <span class="value">{{ userProfile.email }}</span>
        </div>
      </div>
      <div class="detail-item">
        <i class="bi bi-translate"></i>
        <div>
          <span class="label">语言偏好</span>
          <span class="value">简体中文</span>
        </div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="function-menu">
      <div class="menu-section">
        <h3>账号设置</h3>
        <div class="menu-items">
          <div class="menu-item" @click="editProfile">
            <i class="bi bi-person-gear"></i>
            <span>编辑资料</span>
            <i class="bi bi-chevron-right"></i>
          </div>
          <div class="menu-item" @click="changePassword">
            <i class="bi bi-key"></i>
            <span>修改密码</span>
            <i class="bi bi-chevron-right"></i>
          </div>
          <div class="menu-item" @click="notificationSettings">
            <i class="bi bi-bell"></i>
            <span>通知设置</span>
            <i class="bi bi-chevron-right"></i>
          </div>
        </div>
      </div>

      <div class="menu-section">
        <h3>其他</h3>
        <div class="menu-items">
          <div class="menu-item" @click="aboutApp">
            <i class="bi bi-info-circle"></i>
            <span>关于应用</span>
            <i class="bi bi-chevron-right"></i>
          </div>
          <div class="menu-item" @click="feedback">
            <i class="bi bi-chat-dots"></i>
            <span>意见反馈</span>
            <i class="bi bi-chevron-right"></i>
          </div>
          <div class="menu-item logout" @click="logout">
            <i class="bi bi-box-arrow-right"></i>
            <span>退出登录</span>
            <i class="bi bi-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'UserProfile',
  data() {
    return {
      userProfile: store.userProfile,
      articles: [] // 这里可以引入文章数据
    }
  },
  methods: {
    editProfile() {
      this.$toast.info('编辑资料功能开发中...')
    },
    changePassword() {
      this.$toast.info('修改密码功能开发中...')
    },
    notificationSettings() {
      this.$toast.info('通知设置功能开发中...')
    },
    aboutApp() {
      this.$toast.info('面试宝典 v1.0.0')
    },
    feedback() {
      this.$toast.info('意见反馈功能开发中...')
    },
    logout() {
      if (confirm('确定要退出登录吗？')) {
        this.$toast.success('已退出登录')
        // 这里可以添加实际的登出逻辑
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
.profile-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.user-card {
  background: white;
  border-radius: 15px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.avatar-section {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
}

.avatar {
  color: #1890ff;
  font-size: 80px;
}

.edit-avatar-btn {
  position: absolute;
  bottom: 0;
  right: -10px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.user-info h2 {
  color: #1a1a1a;
  font-size: 24px;
  margin-bottom: 5px;
}

.user-email {
  color: #666;
  font-size: 16px;
  margin-bottom: 10px;
}

.user-bio {
  color: #888;
  font-size: 14px;
  margin-bottom: 20px;
}

.user-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 20px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
}

.stat-label {
  font-size: 12px;
  color: #666;
}

.profile-details {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.detail-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-item i {
  color: #1890ff;
  margin-right: 15px;
  font-size: 20px;
}

.detail-item .label {
  color: #666;
  font-size: 14px;
  margin-right: 10px;
}

.detail-item .value {
  color: #1a1a1a;
  font-weight: 500;
}

.function-menu {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.menu-section {
  padding: 20px;
}

.menu-section h3 {
  color: #666;
  font-size: 16px;
  margin-bottom: 15px;
  padding-left: 10px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.menu-item:hover {
  background-color: #f9f9f9;
}

.menu-item i:first-child {
  color: #1890ff;
  margin-right: 15px;
  width: 20px;
}

.menu-item span {
  flex: 1;
  color: #1a1a1a;
}

.menu-item.logout {
  color: #ff4757;
}

.menu-item.logout i {
  color: #ff4757;
}
</style>